import { GsFormControl, GsFormFieldColor, GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { GsStructTextBlock, GsStructTextData } from '../../../models';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the text component form.
 * Defines the fields to display for the form.
 */
export const TEXT_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      // Without a default, unset texts keep inheriting the color of the surrounding block
      formControlName: 'textColor',
      label: 'schema.colors.textColor',
      type: 'color',
      nullable: true
    } as GsFormFieldColor,
    {
      // Attribute for the text content
      type: 'control',
      formControlName: 'data',
      default: {
        blocks: [] as GsStructTextBlock[],
        time: new Date().getTime(),
        version: '2.8.1'
      } as GsStructTextData
    } as GsFormControl<GsStructTextData>
  ]
};
